<template>
  <div class="footer__upper bg-primary text-white">
    <div
      class="footer__upper-content container container--page-content flex flex-col gap-12 py-10 md:py-[60px] md:grid"
      :class="{ 'md:grid-cols-2': !showAIChat, 'md:grid-cols-3': showAIChat }"
    >
      <div class="footer__upper-card flex flex-col gap-5 items-center">
        <svg class="footer__upper-card-icon fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
          <path
            d="M35.9142 25.1528C35.7286 24.9669 35.5082 24.8194 35.2656 24.7188C35.0229 24.6182 34.7628 24.5664 34.5002 24.5664C34.2375 24.5664 33.9774 24.6182 33.7348 24.7188C33.4922 24.8194 33.2718 24.9669 33.0862 25.1528L29.8982 28.3408C28.4202 27.9008 25.6622 26.9008 23.9142 25.1528C22.1662 23.4048 21.1662 20.6468 20.7262 19.1688L23.9142 15.9808C24.1001 15.7952 24.2475 15.5748 24.3482 15.3322C24.4488 15.0896 24.5006 14.8295 24.5006 14.5668C24.5006 14.3041 24.4488 14.0441 24.3482 13.8014C24.2475 13.5588 24.1001 13.3384 23.9142 13.1528L15.9142 5.15281C15.7286 4.96692 15.5082 4.81944 15.2656 4.71882C15.0229 4.6182 14.7628 4.56641 14.5002 4.56641C14.2375 4.56641 13.9774 4.6182 13.7348 4.71882C13.4922 4.81944 13.2718 4.96692 13.0862 5.15281L7.66218 10.5768C6.90218 11.3368 6.47418 12.3808 6.49018 13.4468C6.53618 16.2948 7.29018 26.1868 15.0862 33.9828C22.8822 41.7788 32.7742 42.5308 35.6242 42.5788H35.6802C36.7362 42.5788 37.7342 42.1628 38.4902 41.4068L43.9142 35.9828C44.1001 35.7972 44.2475 35.5768 44.3482 35.3342C44.4488 35.0916 44.5006 34.8315 44.5006 34.5688C44.5006 34.3061 44.4488 34.0461 44.3482 33.8034C44.2475 33.5608 44.1001 33.3404 43.9142 33.1548L35.9142 25.1528ZM35.6602 38.5768C33.1642 38.5348 24.6242 37.8648 17.9142 31.1528C11.1822 24.4208 10.5302 15.8508 10.4902 13.4048L14.5002 9.39481L19.6722 14.5668L17.0862 17.1528C16.8511 17.3877 16.6783 17.6775 16.5833 17.9959C16.4883 18.3144 16.4742 18.6515 16.5422 18.9768C16.5902 19.2068 17.7642 24.6608 21.0842 27.9808C24.4042 31.3008 29.8582 32.4748 30.0882 32.5228C30.4133 32.5927 30.7507 32.5797 31.0695 32.485C31.3882 32.3903 31.678 32.2169 31.9122 31.9808L34.5002 29.3948L39.6722 34.5668L35.6602 38.5768Z"
            fill="currentColor"
          />
        </svg>
        <div class="footer__upper-card-content flex flex-col gap-3 items-center">
          <div class="footer__upper-card-title-text h4">{{ t('footer.upperFooter.phone.title') }}</div>
          <p class="footer__upper-card-content-text text-regular-normal !text-white text-center">
            {{ t('footer.upperFooter.phone.description') }}
          </p>
        </div>

        <a
          href="tel:+43311280100"
          @click="trackPhoneClick()"
          class="footer__upper-card-link text-regular-link !text-white"
          :aria-label="t('menu.tel', { tel: '+43 3112 80100' })"
          :title="t('menu.tel', { tel: '+43 3112 80100' })"
          >+43 3112 80100</a
        >
      </div>

      <div class="footer__upper-card flex flex-col gap-5 items-center">
        <svg class="footer__upper-card-icon fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
          <path
            d="M40.5 8.56738H8.5C6.294 8.56738 4.5 10.3614 4.5 12.5674V36.5674C4.5 38.7734 6.294 40.5674 8.5 40.5674H40.5C42.706 40.5674 44.5 38.7734 44.5 36.5674V12.5674C44.5 10.3614 42.706 8.56738 40.5 8.56738ZM40.5 12.5674V13.5894L24.5 26.0354L8.5 13.5914V12.5674H40.5ZM8.5 36.5674V18.6554L23.272 30.1454C23.6222 30.4205 24.0547 30.57 24.5 30.57C24.9453 30.57 25.3778 30.4205 25.728 30.1454L40.5 18.6554L40.504 36.5674H8.5Z"
            fill="currentColor"
          />
        </svg>
        <div class="footer__upper-card-content flex flex-col gap-3 items-center">
          <div class="footer__upper-card-title-text h4">{{ t('footer.upperFooter.email.title') }}</div>
          <p class="footer__upper-card-content-text text-regular-normal !text-white text-center">
            {{ t('footer.upperFooter.email.description') }}
          </p>
        </div>

        <a
          @click="trackEmailClick()"
          href="mailto:hello@herbertseidl.at"
          class="footer__upper-card-link text-regular-link !text-white"
          :aria-label="t('menu.mailto', { email: 'info@herbertseidl.at' })"
          :title="t('menu.mailto', { email: 'info@herbertseidl.at' })"
          >info@herbertseidl.at</a
        >
      </div>

      <div v-if="showAIChat" class="footer__upper-card flex flex-col gap-5 items-center">
        <svg class="footer__upper-card-icon fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
          <path
            d="M40.5 4.56738H8.5C6.294 4.56738 4.5 6.36138 4.5 8.56738V32.5674C4.5 34.7734 6.294 36.5674 8.5 36.5674H14.5V44.1014L27.054 36.5674H40.5C42.706 36.5674 44.5 34.7734 44.5 32.5674V8.56738C44.5 6.36138 42.706 4.56738 40.5 4.56738ZM40.5 32.5674H25.946L18.5 37.0334V32.5674H8.5V8.56738H40.5V32.5674Z"
            fill="currentColor"
          />
          <path d="M14.5 14.5674H34.5V18.5674H14.5V14.5674ZM14.5 22.5674H28.5V26.5674H14.5V22.5674Z" fill="currentColor" />
        </svg>
        <div class="footer__upper-card-content flex flex-col gap-3 items-center">
          <div class="footer__upper-card-title-text h4">{{ t('footer.upperFooter.aiChat.title') }}</div>
          <p class="footer__upper-card-content-text text-regular-normal !text-white text-center">
            {{ t('footer.upperFooter.aiChat.description') }}
          </p>
        </div>

        <a
          href="tel:+420777123456"
          class="footer__upper-card-link text-regular-link !text-white"
          @click.prevent.stop="startNewChat"
          @click="trackAIChatClick()"
          :aria-label="t('footer.upperFooter.aiChat.buttonLabel')"
          :title="t('footer.upperFooter.aiChat.buttonLabel')"
          >{{ t('footer.upperFooter.aiChat.buttonLabel') }}</a
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n();
  const eventBus = useEventBus();
  const { push } = useDataLayer();

  interface EventData {
    event: 'footer_email_click' | 'footer_phone_click' | 'footer_ai_chat_click';
    page_location: string;
  }

  const props = withDefaults(
    defineProps<{
      showAIChat?: boolean;
    }>(),
    {
      showAIChat: true,
    }
  );

  const startNewChat = () => {
    if (!props.showAIChat) return;
    eventBus.emit('open-aichat-modal');
  };

  const trackEmailClick = () => {
    const eventData: EventData = {
      event: 'footer_email_click',
      page_location: window.location.href,
    };
    push(eventData);
  };

  const trackPhoneClick = () => {
    const eventData: EventData = {
      event: 'footer_phone_click',
      page_location: window.location.href,
    };
    push(eventData);
  };

  const trackAIChatClick = () => {
    const eventData: EventData = {
      event: 'footer_ai_chat_click',
      page_location: window.location.href,
    };
    push(eventData);
  };
</script>
